import moment from 'moment';
import { constants } from '../../constants/common';
import { MasterConfigs } from '../../interfaces/entity';
import { addForm, viewColomn } from '../common';

export const currentOpeningsConfig: MasterConfigs = {
  api: () => '/vendor/crm/current_opening',
  title: 'Current Openings',
  isActionTab: true,
  maskClosable: false,
  modalTitle: (action) => action + ' Openings',
  isSteps: true,
  getColumns: () => {
    return [
      {
        title: 'Job ID',
        dataIndex: 'jobId',
        key: 'jobId',
      },
      {
        title: 'Department',
        dataIndex: 'department',
        key: 'department',
        render: (text) => text?.name
      },
      {
        title: 'Job Title',
        dataIndex: 'jobTitle',
        key: 'jobTitle',
        render: (text) => text?.name
      },
      {
        title: 'Employment Type',
        dataIndex: 'employmentType',
        key: 'employmentType',
        align: 'center',
      },
      {
        title: 'Job Location Type',
        dataIndex: 'jobLocationType',
        key: 'jobLocationType',
        align: 'center',
      },
      {
        title: 'Work Location',
        dataIndex: 'workLocation',
        key: 'workLocation',
        align: 'center',
      },
      {
        title: 'Test Name',
        dataIndex: 'testName',
        key: 'testName',
        render: (text) => text?.name
      },
      {
        title: 'Expire Date',
        dataIndex: 'validTill',
        key: 'validTill',
        align: 'center',
        render: (text) => text ? moment(text).format('DD MMM, YYYY') : ''
      }
    ];
  },
  getFormColumns: () => {
    return [
      {
        api: () => '/vendor/crm/current_opening',
        tabName: 'Job Configuration',
        getChiledForm: () => [
          {
            label: 'Job ID',
            name: 'jobNumber',
            type: 'select',
            isCombo: true,
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Department',
            name: 'department',
            key: 'department',
            type: 'select',
            rules: [{
              required: true,
              message: 'Field is required'
            }],
            isCombo: true,
          },
          {
            label: 'Job Title',
            name: 'jobTitle',
            key: 'jobTitle',
            type: 'select',
            isCombo: true,
          },
          {
            label: 'Employment Type',
            name: 'employmentType',
            type: 'DynamicSelect',
            dynamicProps: {
              keyName: 'employmentType',
              searchApi: '/vendor/options/list',
              isEncrypted: true
            },
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Mandatory Technical Skills',
            name: 'skils',
            type: 'DynamicSelect',
            dynamicProps: {
              multiple: true,
              keyName: 'skillName',
              searchApi: '/vendor/options/list',
              isEncrypted: true,
            },
            selectProps: { maxCount: 4 },
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Job Location Type',
            name: 'jobLocationType',
            type: 'select',
            children: ['Remote', 'Onsite', 'Hybrid'].map(ele => ({ name: ele, value: ele })),
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Work Location',
            name: 'workLocation',
            type: 'DynamicSelect',
            dynamicProps: {
              keyName: 'workLocation',
              searchApi: '/vendor/options/list',
              isEncrypted: true,
            },
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Years of Experience',
            name: 'experiance',
            type: 'number',
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Interview Rounds',
            name: 'interviewRounds',
            type: 'number',
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Currency',
            name: 'currency',
            type: 'select',
            children: ['INR', 'USD'].map(ele => ({ name: ele, value: ele })),
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Interval',
            name: 'interval',
            type: 'select',
            children: ['Monthly', 'Yearly', 'Hourly', 'Weekly', 'Fixed'].map(ele => ({ name: ele, value: ele })),
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Minimum',
            name: 'minimum',
            type: 'number',
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Maximum',
            name: 'maximum',
            type: 'number',
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Valid Till',
            name: 'validTill',
            type: 'date',
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Show Budget on JD',
            name: 'showBudget',
            type: 'select',
            children: ['Yes', 'No'].map(ele => ({ name: ele, value: ele })),
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          },
          {
            label: 'Test Name',
            name: 'testName',
            type: 'select',
            isCombo: true,
          }
        ]
      },
      {
        api: () => '/vendor/crm/current_opening',
        tabName: 'Job Details',
        getChiledForm: () => [
          {
            label: "Job Description",
            name: "jobDescription",
            type: "quill",
            span: 24,
            rules: [{
              required: true,
              message: 'Field is required'
            }]
          }
        ]
      },
      {
        api: () => '/vendor/crm/current_opening',
        tabName: 'Pre Interview Questions',
        getChiledForm: () => [
          {
            label: 'Pre Interview Questions',
            name: 'interviewQuestions',
            key: 'interviewQuestions',
            type: 'form',
            span: 24,
            form: [
              {
                label: 'Question Type',
                name: 'fieldType',
                key: 'fieldType',
                type: 'select',
                children: ['number', 'checkbox', 'select', 'textarea', 'radio', 'date'].map(ele => ({ name: ele, value: ele })),
              },
              {
                label: 'Question',
                name: 'label',
                key: 'label',
                type: 'text',
              },
              {
                label: 'Is Required',
                name: 'required',
                key: 'required',
                type: 'select',
                children: ['Yes', 'No'].map(ele => ({ name: ele, value: ele })),
              },
              {
                label: 'Options',
                name: 'options',
                key: 'options',
                type: 'text',
                placeholder: 'Add coma seprated',
              },
            ]
          },
        ]
      }
      // ...addForm()
    ];
  },
  combo: [
    {
      name: 'testName',
      api: '/online-test-settings',
      idKey: '_id',
      render: (text) => text.name
    },
    {
      name: 'jobNumber',
      api: '/job-number-series',
      idKey: '_id',
      render: (text) => text.name
    },
    {
      name: 'jobTitle',
      api: '/job-titles',
      idKey: '_id',
      render: (text) => text.name
    },
    {
      name: 'interviewer',
      api: '/slots/',
      idKey: '_id',
      render: (text) => {
        return text ? [text.slotsFor.firstName, text.slotsFor.lastName].join(' ') : '';
      },
    },
    {
      name: 'department',
      api: '/departments',
      idKey: '_id',
      render: (text) => text.name
    },

  ],
  getData: () => ({}),
  actions: [
    { name: 'Add JD', actionType: 'Add' },
    { name: 'Return', actionType: 'Back' },
  ],
};
